export enum ACTION_TOOLTIPS {
    RESOLVE = "Resolve Order´s Queue",
    RECALL = "Recall Order",
    OVERWRITE = "Overwrite CU Score",
    REOPEN = "ReOpen Order",
    ACCESS = "Access Order",
	DISABLED = "Click to view more"
}
